import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, redirect, } from "react-router-dom";
import { JobBoard } from "./components/JobBoard";
import { SearchParamType } from "./types/SearchParamType";
function hasJobBoardSearchParams(searchParams) {
    var keys = Array.from(searchParams.keys());
    var jobBoardParams = Object.values(SearchParamType);
    return keys.some(function (key) { return jobBoardParams.includes(key); });
}
function createJobBoardLoader(filters) {
    return function (_a) {
        var request = _a.request;
        var url = new URL(request.url);
        var searchParams = url.searchParams;
        if (!hasJobBoardSearchParams(searchParams) && filters && filters.size > 0) {
            filters.forEach(function (value, key) {
                searchParams.set(key, value);
            });
            return redirect("?".concat(searchParams.toString()));
        }
        return null;
    };
}
export function router(filters) {
    var mainRoute = [
        {
            path: "/",
            element: _jsx(JobBoard, {}),
            loader: createJobBoardLoader(filters),
        },
    ];
    return createBrowserRouter(mainRoute, { basename: window.location.pathname });
}
